function Filters(props) {
  const filterData = () => {
    const { data = [], filter = '', keys = [] } = props;

    if (!filter) {
      return data;
    }

    const search = String(filter).toLowerCase();

    const contains = value => {
      if (value === null || value === undefined) {
        return false;
      }

      if (typeof value === 'object') {
        return Object.entries(value).some(([key, val]) => {
          if (keys.length) {
            return String(val).toLowerCase().includes(search) && keys.includes(key);
          }
          return String(key).toLowerCase().includes(search) || contains(val);
        });
      }

      return String(value).toLowerCase().includes(search);
    };

    // Array: return matching objects
    if (Array.isArray(data)) {
      return data.filter(item => {
        return Object.keys(item).some(key => {
          return String(item[key]).toLowerCase().includes(search);
        });
      });
    }

    // Object: return only matching properties
    if (data && typeof data === 'object') {
      return Object.fromEntries(
        Object.entries(data).filter(([key, value]) =>
          String(key).toLowerCase().includes(search) ||
          contains(value)
        )
      );
    }

    return contains(data) ? data : null;
  };

  return props.renderData(filterData());
}

export default Filters;
